import FrameworkView from "./View.js";
import oktaUnderscore from "../util/underscore-wrapper.js";
var ListView = FrameworkView.extend(
  /** @lends src/framework/ListView.prototype */
  {
    constructor: function() {
      FrameworkView.apply(this, arguments);
      if (!this.collection) {
        throw new Error("Missing collection");
      }
      this.listenTo(this.collection, "reset sort", this.reset);
      this.listenTo(this.collection, "add", this.addItem);
      if (this.fetchCollection) {
        this.collection.fetch();
      } else {
        this.collection.each(this.addItem, this);
      }
    },
    /**
       * The view/template we will use to render each model in the collection.
       * @type {String|module:Okta.View}
       */
    item: null,
    /**
       * A selector in the local template where to append each item
       * @type {String}
       */
    itemSelector: null,
    /**
       * Empty the list and re-add everything from the collection.
       * Usefull for handling `collection.reset()` or for handling the initial load
       * @protected
       */
    reset: function() {
      this.removeChildren();
      this.collection.each((model, index) => {
        this.addItem(model, index);
      });
      return this;
    },
    /**
       * Add an item view to the list that will represent one model from the collection
       *
       * Listen to the model so when it is destoyed or removed from the collection
       * this item will remove itself from the list
       *
       * @param {Backbone.Model} model The model this row operates on
       * @protected
       */
    addItem: function(model) {
      var view = this.add(this.item, this.itemSelector, {
        options: {
          model
        }
      }).last();
      if (this.state && this.state.get("trackItemAdded")) {
        this.state.trigger("itemAdded", view);
      }
      view.listenTo(model, "destroy remove", view.remove);
      return this;
    },
    addShowMore: oktaUnderscore.noop
  }
);
export { ListView as default };
